<ng-container>
    <div *ngIf="blnError"></div>
    <p style="padding-top: 20px; padding-left: 20px;" [innerHTML]="global_msg">  </p>
    <div *ngIf="pageLoad" class="clsBorder">
        <div *ngFor="let doc of allDocs;let i = index" class="row">
        
            <div class="col-md-4 col-sm-6 col-12">
                <div class="field-bg field-bg-file">
                    <!-- <input disabled [id]="'NRdocTypeShow'+i+docType" [name]="'NRdocTypeShow'+i+docType" [(ngModel)]="doc.documentType"> -->
                    <span [id]="'NRdocTypeShow'+i+docType" >{{doc.documentType}} </span>

                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label style="margin-top: -38px;" [for]="'NRdocTypeShow'+i+docType">Document Type </label>
                </div>
            </div>
            <div class="col-md-4 col-sm-6 col-12">
                <div class="field-bg field-bg-file">
                    <a [id]="'a_NRdocNameShow'+i+docType" style=" cursor: pointer;" href="javascript:void(0)" (click)="fnDownloadDoc(doc.documentAzureName)">
                        <span [id]="'span_NRdocNameShow'+i+docType" class="bar">{{doc.documentName}} </span>
                    </a>
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label style="top:-22px" [for]="'NRdocNameShow'+i+docType">Document Name</label>
                    <!--<p class="para" style="font-size:12px !important">-->
                    <!--    <span *ngIf="doc['status'].toLowerCase()=='invalid'" style="color: #F95431;">{{doc['status']}}</span>-->
                    <!--    <span *ngIf="doc['status'].toLowerCase()!='invalid'" style="color: #32CD32;">{{doc['status']}}</span>-->
                    <!--     | {{doc['remarks']}}</p>-->
                </div>
            </div>
            <div *ngIf="windowFlag" class="col-md-12 col-lg-4 col-12">
                <a href="javascript:void(0)" class="sp2_delete-icon" (click)="fnDeleteDocument(doc)"></a>

            </div>
        </div>
    </div>
</ng-container>
<div *ngIf="confirmationPopup" class="modal fade show" id="modal-confirm-taxform" style="display: block; padding-right: 17px;background: rgba(0,0,0,0.5);" aria-modal="true">
        <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content">
                    <div class="modal-body pad0 text-center marT30">
                            <!-- <button type="button" class="close" data-dismiss="modal" (click)="closeModalPopup()">&times;
                           </button> -->
                           <div class="clearfix pt-4"><img src="assets/images/icon-success.png" alt="success"></div>
                           <p class="modal-message">File deleted succesfully!!</p>
                           <hr class="horz-divider">
                           <div class="text-center"><button class="btn-primary" data-dismiss="modal" type="button" (click)="closeModalPopup()">Ok</button></div>
                       </div>
            </div>
        </div>
</div>